import { IsBoolean, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class CorrectCleaningRecordDto {
  @IsBoolean()
  isCompliant!: boolean;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  reason?: string;
}
